import * as React from 'react';

import { StyleSheet } from 'react-native';

import { getDesignToken, spacing } from 'styles/constants';

import { Box } from './box';
import { IListItemGroupProps } from './list-item-group.types';
import { Typography } from './typography';

/**
 *
 * ListItemGroup provides a consistent layout to wrap list item rows in a header and footer
 *
 */
export const ListItemGroup: React.FC<React.PropsWithChildren<IListItemGroupProps>> = ({
  items,
  header,
  headerAction,
  subHeader,
  footer,
  isNested,
  ItemSeparator,
  testID = 'list-item-group',
}) => {
  if (!items?.length) {
    return null;
  }

  return (
    <Box testID={testID} style={styles.group}>
      {(header || headerAction) && (
        <Box style={styles.headerWrapper}>
          <Typography
            variant={isNested ? 'headerFour' : 'headerThree'}
            style={styles.headerText}
            focusable
            testID="list-item-group-header"
          >
            {header}
          </Typography>
          {headerAction}
        </Box>
      )}
      {subHeader && (
        <Typography variant="copyTwo" style={styles.subHeaderText}>
          {subHeader}
        </Typography>
      )}
      <Box testID="list-item-group-items">
        {items.map((item, index) => (
          <Box key={`list-item-group-items-${index}`}>
            {item}
            {index < items.length - 1 && ItemSeparator}
          </Box>
        ))}
        {footer ? (
          <Box style={styles.footer} testID="list-item-group-footer">
            {footer}
          </Box>
        ) : undefined}
      </Box>
    </Box>
  );
};

const styles = StyleSheet.create({
  group: {
    backgroundColor: getDesignToken('background-card'),
    marginBottom: spacing.$2,
  },
  headerWrapper: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: spacing.$6,
    paddingBottom: spacing.$2,
    paddingHorizontal: spacing.$4,
  },
  footer: {
    alignItems: 'center',
    borderBottomWidth: 1,
    borderBottomColor: '#dcdcdc',
    flexDirection: 'row',
    justifyContent: 'space-between',
    minHeight: spacing.$10,
    paddingHorizontal: spacing.$4,
    paddingVertical: spacing.$1,
  },
  subHeaderText: {
    paddingHorizontal: spacing.$1,
    paddingVertical: 1,
    marginTop: -2,
    marginBottom: 0,
  },
  headerText: {
    flex: 1,
    margin: 0,
    marginBottom: 0,
    paddingRight: spacing.$2,
  },
});
